<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" :id="id">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <i class="fa-solid fa-arrow-down-wide-short"></i>
                        <strong>
                            {{selected[name]}}
                        </strong>
                        の移動
                    </h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="form-group" v-if="selected">
                        <div class="small">移動先を選択してください。</div>
                        <div class="list-group">
                            <button type="button"
                                class="list-group-item list-group-item-action"
                                :class="{
                                    'selected': r.id == selected.id,
                                    'list-group-item-secondary': isHeader(r)
                                }"
                                @click.prevent="move(r.id)"
                                :id="'sort-' + r.id"
                                v-for="(r, i) in records" :key="r.id">
                                <i class="fas fa-check" v-if="selected.id === r.id"></i>
                                <i class="fas fa-sort-up" v-else-if="selectedIndex > i"></i>
                                <i class="fas fa-sort-down" v-else-if="selectedIndex < i"></i>
                                {{r[name]}}
                                <span v-if="selected.id === r.id" class="small">
                                    移動をキャンセル
                                </span>
                                <span v-else-if="selectedIndex > i" class="small">
                                    の前に移動
                                </span>
                                <span v-else class="small">
                                    の後に移動
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.selected {
    background-color: #3490dc !important;
    color: white;
    &:hover {
        background-color: #3490dc !important;
        color: white;
    }
}
</style>

<script>
export default {
    props: {
        id: {
            default: "sort-modal"
        },
        selected: {
            default: null,
        },
        records: {
            default: []
        },
        name: {
            require: true,
            default: null
        },
        header: {
            default: null
        }
    },
    methods: {
        close(id) {
            this.$emit("close", this.id);
        },
        move(to_id = null) {
            if (to_id !== this.selected.id) {
                this.$emit("moveTo", to_id);
            }
            this.close();
        },
        isHeader(r) {
            const not = this.header.match(/^\!([a-z]+)/i);
            if (not) {
                return !r[not[1]];
            } else if (this.header) {
                return r[this.header];
            }
            return false;
        },
    },
    computed: {
        selectedIndex() {
            return _.findIndex(this.records, {id: this.selected.id});
        }
    },
}
</script>